module.exports = __webpack_public_path__ + "img/ImageGalleryNextIcon.79720705.png";